import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { REACTIONS_LOVE } from "@/components/LoveSwipe";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/** Les 4 réactions FodindinLove (coucou / j'aime / coup de cœur / ça chauffe).
 *  Utilisable partout où un profil Love apparaît : fil de swipe, matchs, annonces. */
export const ReactionsLove = ({ cibleId, annonceId, moiId, reactionInitiale, onMatch, compact }) => {
  const [choisie, setChoisie] = useState(reactionInitiale || null);
  const [enCours, setEnCours] = useState(null);

  const reagir = async (cle) => {
    if (!moiId) return toast.error("Créez votre profil Love pour réagir.");
    if (cibleId === moiId) return toast.error("On ne réagit pas à son propre profil.");
    setEnCours(cle);
    try {
      const r = await axios.post(`${API}/love/reaction`, {
        auteur_id: moiId, cible_id: cibleId, type: cle,
      });
      setChoisie(cle);
      // Le compteur de cœurs de l'annonce reste alimenté par le coup de cœur.
      if (annonceId && (cle === "coeur" || cle === "feu")) {
        axios.post(`${API}/fodindinlove/annonces/${annonceId}/liker`, { profile_id: moiId })
          .catch(() => {});
      }
      if (r.data.match) onMatch?.(r.data.cible);
      else toast.success(r.data.message);
    } catch (e) {
      const d = e.response?.data?.detail;
      toast.error(typeof d === "string" ? d : d?.message || "Réaction impossible.");
    } finally {
      setEnCours(null);
    }
  };

  return (
    <div className={`flex items-center justify-between gap-1.5 ${compact ? "" : "border-t border-stone-100 pt-3"}`}
      data-testid={`reactions-love-${cibleId}`}>
      {REACTIONS_LOVE.map(({ cle, label, Icone, couleur }) => (
        <button key={cle} title={label} onClick={() => reagir(cle)} disabled={enCours === cle}
          data-testid={`love-reaction-${cle}-${annonceId || cibleId}`}
          className="flex flex-1 flex-col items-center gap-1 rounded-2xl py-2 transition-transform hover:scale-110 active:scale-95 disabled:opacity-50"
          style={{
            backgroundColor: choisie === cle ? `${couleur}1a` : "transparent",
            color: choisie === cle ? couleur : "#78716C",
          }}>
          <Icone size={compact ? 18 : 20} />
          <span className="text-[10px] font-bold leading-none">{label}</span>
        </button>
      ))}
    </div>
  );
};
